import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';

export function stopSharingMutation(builder: WebapiEndpointBuilder) {
  return builder.mutation<void, { tabId: string }>({
    query: (body) => ({
      url: `/userdata/workspace/shared/${body.tabId}/${WORKSPACE_VERSION}`,
      method: 'DELETE',
    }),
  });
}
